import type * as React from "react";
import { HomeBookingSection } from "@/components/home/HomeBookingSection";
import Image from "next/image";

const Home: React.FC = () => {
  return (
    <>
    <section className="bg-gray-800 mx-auto flex flex-col items-center h-[calc(100vh-64px)] bg-cover bg-center" style={{ backgroundImage: "url('/blure_bg_car.png')" }}>
      <HomeBookingSection />
    </section>

    <section className="max-w-340 my-12 mx-20">
      <h1 className="font-bold text-6xl text-center my-24">Your One stop Transport Solution</h1>

      <div className="max-w-340 h-160 rounded-4xl bg-cover bg-center overflow-hidden " style={{ backgroundImage: "url('/pasengers.png')" }}>
        <div className="bg-gradient-to-tr from-neutral-900 via-transparent to-transparent px-15 pb-15 max-w-340 h-160 flex items-end">
          <div className="flex flex-col gap-1.5">
            <h2 className="text-4xl font-bold text-gray-50">Cars & Passenger Vehicles for Rent</h2>
            <p className="text-lg text-gray-200">Explore the road with confidence through our wide selection of cars and passenger vehicles</p>
          </div>
        </div>
      </div>

      <div className="max-w-340 grid grid-cols-2 gap-12 h-130 mt-12">
        <div className="bg-cover overflow-hidden rounded-4xl" style={{ backgroundImage: "url('/delivery-van.png')" }}>
          <div className="bg-gradient-to-t from-neutral-900 via-transparent to-transparent px-10 pb-10 max-w-340 h-130 flex items-end">
            <div className="flex flex-col gap-1.5">
              <h2 className="text-3xl font-bold text-gray-300">Household Moving & Delivery</h2>
              <p className="text-lg text-gray-400">Moving your home with care, safety, and reliability</p>
            </div>
          </div>
        </div>
        <div className="bg-cover overflow-hidden rounded-4xl" style={{ backgroundImage: "url('/heavy-vehicle.png')" }}>
          <div className="bg-gradient-to-t from-neutral-900 via-transparent to-transparent px-10 pb-10 max-w-340 h-130 flex items-end">
            <div className="flex flex-col gap-1.5">
              <h2 className="text-3xl font-bold text-gray-300">Commercial Delivery Vehicles</h2>
              <p className="text-lg text-gray-400">Perfect for business deliveries and transportation needs</p>
            </div>
          </div>
        </div>
      </div>

      
    </section>
    </>
  );
};

export default Home;
